<template functional>
  <li class="menu-item" v-on="listeners">
    <slot v-bind:text="props.text">
      <a :href="props.url" v-bind="props.anchorAttrs">
        {{ props.text }}
      </a>
    </slot>
  </li>
</template>

<script>
export default {
  name: 'NavMenuItem',

  props: {
    /** Text which is to be shown in the component */
    text: {
      type: String,
      required: true
    },
    /** Link to redirect to on-click */
    url: {
      type: String,
      required: true
    },
    /** Object value for additional attributes/properties for the nested anchor tag */
    anchorAttrs: Object
  }
}
</script>

<style lang="scss" scoped>
.menu-item {
  line-height: 24px;
  text-align: left;
}
</style>
